import { Routes, Route } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { LanguageProvider, localizePath } from './contexts/LanguageContext'

// Components
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

// Pages
import Home from './pages/Home'
import Features from './pages/Features'
import Pricing from './pages/Pricing'
import Support from './pages/Support'
import Download from './pages/Download'
import Contact from './pages/Contact'
import About from './pages/About'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'
import ProductionCosting from './pages/ProductionCosting'
import BendCosting from './pages/BendCosting'
import LaserCosting from './pages/LaserCosting'
import TubeLaserCosting from './pages/TubeLaserCosting'
import DxfStepImport from './pages/DxfStepImport'
import SolidWorksPlugin from './pages/SolidWorksPlugin'
import InventorPlugin from './pages/InventorPlugin'
import QuotationSoftware from './pages/QuotationSoftware'
import SheetMetalCosting from './pages/SheetMetalCosting'
import ManufacturingCostEstimator from './pages/ManufacturingCostEstimator'
import MetalPartsCosting from './pages/MetalPartsCosting'
import CncMillingCosting from './pages/CncMillingCosting'
import CostCalculator from './pages/CostCalculator'

// Every page is served twice: English at its path, Greek under /el.
const pages = [
  ['/', Home],
  ['/features', Features],
  ['/pricing', Pricing],
  ['/support', Support],
  ['/download', Download],
  ['/contact', Contact],
  ['/about', About],
  ['/privacy', Privacy],
  ['/terms', Terms],
  ['/sheet-metal-costing', SheetMetalCosting],
  ['/production-costing', ProductionCosting],
  ['/bend-costing', BendCosting],
  ['/laser-costing', LaserCosting],
  ['/tube-laser-costing', TubeLaserCosting],
  ['/dxf-step-import', DxfStepImport],
  ['/solidworks-plugin', SolidWorksPlugin],
  ['/inventor-plugin', InventorPlugin],
  ['/quotation-software', QuotationSoftware],
  ['/manufacturing-cost-estimator', ManufacturingCostEstimator],
  ['/metal-parts-costing', MetalPartsCosting],
  ['/cnc-milling-costing', CncMillingCosting],
  ['/cost-calculator', CostCalculator],
]

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen flex flex-col">
        <ScrollToTop />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            {pages.map(([path, Page]) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            {pages.map(([path, Page]) => (
              <Route key={`el${path}`} path={localizePath(path, 'el')} element={<Page />} />
            ))}
          </Routes>
        </main>
        <Footer />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </LanguageProvider>
  )
}

export default App
